{
  "collectionLabel": "候補"
}
